module.exports = __webpack_public_path__ + "static/media/print.e75ae008.svg";